import { Map } from 'immutable';
import {
    GET_PHOTOS_SUCCESS,
    GET_PHOTOS_FAIL,
    DELETE_PHOTO_SUCCESS,
    DELETE_PHOTO_FAIL,
    SELECT_PHOTO,
    GET_PHOTO_FAULTS_SUCCESS,
    REMOVE_PHOTO_SELECTION,
} from '../types/photos';
import {
    SELECT_FLIGHT
} from '../types/flightManager';
import {
    SIGN_OUT,
} from '../types/auth';

const INITIAL_MAP = Map({
    photos: [],
    message: { type: 'info', text: '' },
    selectedPhotoId: null,
    photoFaults: []
});

export default (state = INITIAL_MAP, action) => {
    switch (action.type) {
        case GET_PHOTOS_SUCCESS:
            return state
                .set('photos', action.photos)

        case GET_PHOTOS_FAIL:
            return state
                .set('message', { type: 'error', text: action.error.response.data })
                .set('photos', null);

        case DELETE_PHOTO_SUCCESS:
            const photos = state.get('photos');
            const updatedData = photos.filter((photo) => {
                return photo.id !== action.photoId;
            })
            return state
                .set('photos', updatedData);

        case DELETE_PHOTO_FAIL:
            return state
                .set('message', { type: 'error', text: 'Error occured while deleting photo' });

        case GET_PHOTO_FAULTS_SUCCESS:
            return state
                .set('photoFaults', action.photoFaults);

        case SELECT_PHOTO:
            return state
                .set('selectedPhotoId', action.photoId);

        case SELECT_FLIGHT:
            if (action.chosenFlight === null)
                return state
                    .set('selectedPhotoId', null)
            else return state;

        case SIGN_OUT:
            return INITIAL_MAP;

        case REMOVE_PHOTO_SELECTION:
            return state
                .set('selectedPhotoId', null);

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/photos.jsx